export function required(value) {
	return (value.trim() !== '');
}

export function email(value) {
	// The api's own check (zod's default email pattern, after trim and
	// lowercase), so the dialog never passes an address the api will refuse.
	// The old emailregex.com pattern was unanchored: it accepted any value
	// that merely contained an address, like "test bob@example.com".
	const pattern = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/;
	return pattern.test(value.trim());
}

export function fullName(value) {
	const pattern = /\S{2,}\s+\S{2,}/;
	return pattern.test(value.trim());
}

export function url(value) {
	// This is pretty permissive
	const pattern = /^((https?:\/\/)?[a-z0-9][a-z0-9-]+(\.[a-z0-9][a-z0-9-]*)+\/?)?$/;
	return pattern.test(value.trim());
}
